import React from 'react';

const cx = (...v) => v.filter(Boolean).join(' ');

export default function FormField({
  label,
  helper,
  error,
  required = false,
  className = '',
  children,
}) {
  return (
    <div className={className}>
      <label className="mb-1 block text-[11px] font-semibold uppercase tracking-[0.08em] text-[#93a8c1]">
        {label}
        {required ? ' *' : ''}
      </label>
      {children}
      {error ? (
        <p className="mt-1 text-xs text-[#ff8f8f]">{error}</p>
      ) : helper ? (
        <p className={cx('mt-1 text-[11px]', error ? 'text-[#ff8f8f]' : 'text-[#7f93ac]')}>{helper}</p>
      ) : null}
    </div>
  );
}
